import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect, useHistory } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import BackButton from "../ChildComponent/BackButton";
import MdlSelectSession from "../dialog/MdlSelectSession";

/** YYYY-MM from a transaction date string (client-side month filter). */
function txnTransactionYearMonth(transactionDate) {
  if (!transactionDate) return "";
  const d = new Date(transactionDate);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/** Lowercase blob of visible fields for quick list search. */
function txnListRowSearchText(r) {
  return [
    r.reciept_no,
    r.transaction_id,
    r.student_id,
    r.stu_name,
    r.father_name,
    r.class_name,
    r.session_name,
    r.transaction_date,
    r.transaction_for,
    r.payment_mode,
    r.paid_amount,
    r.student_roll_no,
    r.roll_no,
    r.sr_admission_no,
  ]
    .map((p) => String(p ?? "").toLowerCase())
    .join(" ");
}

const TransactionPanel = () => {
  const history = useHistory();
  
  // Helper function to format date as YYYY-MM-DD using local time (avoids timezone issues)
  // Memoized to avoid recreating on every render
  const formatDateLocal = useCallback((date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;

    
  }, []);
  
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [feeBatchLoading, setFeeBatchLoading] = useState(false);
  const [mFeeCollectionBatch, setMFeeCollectionBatch] = useState([]);
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [CLASS_ID, setCLASS_ID] = useState("");
  const [SECTION_ID, setSECTION_ID] = useState("");
  const [SELECTED_CLASS_POSITION, setSELECTED_CLASS_POSITION] = useState(-1);
  const [CLASS_SECTION_NAME, setCLASS_SECTION_NAME] = useState("");
  const [mOptions, setMOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [mSessionList, setMSessionList] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [selectedSessionName, setSelectedSessionName] = useState("");
  const [selectedSessionStatus, setSelectedSessionStatus] = useState("");
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [mClassData, setMClassData] = useState([]);
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [mFilteredClassSectionList, setMFilteredClassSectionList] = useState([]);
  const [selectedBoardId, setSelectedBoardId] = useState("");
  const [selectedMediumId, setSelectedMediumId] = useState("");
  const [filterClassList, setFilterClassList] = useState([]); // All classes for filter dropdown
  const [reportType, setReportType] = useState("today");
  // Filter and Sort states
  const [filterClass, setFilterClass] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterSession, setFilterSession] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterMode, setFilterMode] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [txnListSearch, setTxnListSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRangePreset, setDateRangePreset] = useState("");
  const [showCalendar, setShowCalendar] = useState(true);
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [selectingStartDate, setSelectingStartDate] = useState(true);
  const [sessionStartDate, setSessionStartDate] = useState("");

  //Created By Cursor
  const parseLooseDate = useCallback((raw) => {
    const value = String(raw || "").trim();
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
      const d = new Date(value.slice(0, 10) + "T00:00:00");
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const m = value.match(/^(\d{2})-(\d{2})-(\d{4})/);
    if (m) {
      const d = new Date(`${m[3]}-${m[2]}-${m[1]}T00:00:00`);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }, []);

  //Created By Cursor — session start → today (same as CollectionReport)
  const resolveAsOnDateBounds = useCallback(() => {
    const today = formatDateLocal(new Date());
    const start = parseLooseDate(sessionStartDate);
    return {
      from: start ? formatDateLocal(start) : today,
      to: today,
    };
  }, [formatDateLocal, parseLooseDate, sessionStartDate]);

  const mFeeCollectionBatchFilteredSorted = useMemo(() => {
    const batch = mFeeCollectionBatch || [];
    let fcClass = "";
    let fcSection = "";
    if (filterClass) {
      const u = filterClass.indexOf("_");
      if (u >= 0) {
        fcClass = filterClass.slice(0, u);
        fcSection = filterClass.slice(u + 1);
      }
    }
    const filterModeUpper = filterMode ? filterMode.toUpperCase() : "";
    const searchQ = (txnListSearch || "").trim().toLowerCase();

    const rows = batch.filter((r) => {
      if (
        fcClass !== "" &&
        (String(r.class_id ?? "") !== fcClass ||
          String(r.section_id ?? "") !== fcSection)
      ) {
        return false;
      }
      if (
        filterMonth &&
        txnTransactionYearMonth(r.transaction_date) !== filterMonth
      ) {
        return false;
      }
      if (filterSession && String(r.session_id ?? "") !== filterSession) {
        return false;
      }
      if (filterType && String(r.transaction_for ?? "") !== filterType) {
        return false;
      }
      if (
        filterModeUpper &&
        String(r.payment_mode ?? "").toUpperCase() !== filterModeUpper
      ) {
        return false;
      }
      if (searchQ && !txnListRowSearchText(r).includes(searchQ)) {
        return false;
      }
      return true;
    });

    if (!sortBy) return rows;

    const mult = sortOrder === "DESC" ? -1 : 1;
    return [...rows].sort((a, b) => {
      switch (sortBy) {
        case "student_name": {
          const va = (a.stu_name || "").toLowerCase();
          const vb = (b.stu_name || "").toLowerCase();
          if (va < vb) return -mult;
          if (va > vb) return mult;
          return 0;
        }
        case "roll_no": {
          const va = String(
            a.student_roll_no ?? a.roll_no ?? a.sr_admission_no ?? ""
          );
          const vb = String(
            b.student_roll_no ?? b.roll_no ?? b.sr_admission_no ?? ""
          );
          return mult * va.localeCompare(vb, undefined, { numeric: true });
        }
        case "transaction_date": {
          const ta = new Date(a.transaction_date || 0).getTime();
          const tb = new Date(b.transaction_date || 0).getTime();
          return mult * (ta - tb);
        }
        case "amount_paid": {
          const va = Number(a.paid_amount) || 0;
          const vb = Number(b.paid_amount) || 0;
          return mult * (va - vb);
        }
        default:
          return 0;
      }
    });
  }, [
    mFeeCollectionBatch,
    filterClass,
    filterMonth,
    filterSession,
    filterType,
    filterMode,
    txnListSearch,
    sortBy,
    sortOrder,
  ]);

  const feeBatchTotalPaid = useMemo(() => {
    return (mFeeCollectionBatchFilteredSorted || []).reduce((sum, row) => {
      const v = Number(row.paid_amount);
      return sum + (Number.isFinite(v) ? v : 0);
    }, 0);
  }, [mFeeCollectionBatchFilteredSorted]);

  const [selectedTxnIds, setSelectedTxnIds] = useState([]);
  const [txnActionLoading, setTxnActionLoading] = useState(false);

  const handleDateRangePreset = (preset) => {
    const today = new Date();
    let newStartDate = "";
    let newEndDate = "";

    switch (preset) {
      case "today":
        newStartDate = newEndDate = formatDateLocal(today);
        break;
      case "yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        newStartDate = newEndDate = formatDateLocal(yesterday);
        break;
      case "thisWeek":
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());
        newStartDate = formatDateLocal(startOfWeek);
        newEndDate = formatDateLocal(today);
        break;
      case "lastWeek":
        const lastWeekEnd = new Date(today);
        lastWeekEnd.setDate(today.getDate() - today.getDay() - 1); // Last day of last week (Sunday)
        const lastWeekStart = new Date(lastWeekEnd);
        lastWeekStart.setDate(lastWeekEnd.getDate() - 6); // First day of last week (Monday)
        newStartDate = formatDateLocal(lastWeekStart);
        newEndDate = formatDateLocal(lastWeekEnd);
        break;
      case "last7Days":
        const last7Days = new Date(today);
        last7Days.setDate(today.getDate() - 7);
        newStartDate = formatDateLocal(last7Days);
        newEndDate = formatDateLocal(today);
        break;
      case "thisMonth":
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        newStartDate = formatDateLocal(startOfMonth);
        newEndDate = formatDateLocal(today);
        break;
      case "lastMonth":
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        newStartDate = formatDateLocal(firstDayLastMonth);
        newEndDate = formatDateLocal(lastDayLastMonth);
        break;
      case "last30Days":
        const last30Days = new Date(today);
        last30Days.setDate(today.getDate() - 30);
        newStartDate = formatDateLocal(last30Days);
        newEndDate = formatDateLocal(today);
        break;
      case "custom":
        // Keep existing dates, just mark as custom
        break;
      default:
        return;
    }

    setDateRangePreset(preset);
    setStartDate(newStartDate || startDate);
    setEndDate(newEndDate || endDate);
  };

  const handleCalendarDateClick = (date) => {
    const dateStr = formatDateLocal(date);
    
    if (selectingStartDate || !startDate || dateStr < startDate) {
      // Start new selection
      setStartDate(dateStr);
      setEndDate("");
      setSelectingStartDate(false);
      setDateRangePreset("custom");
    } else {
      // Complete the range
      setEndDate(dateStr);
      setSelectingStartDate(true);
      setDateRangePreset("custom");
    }
  };

  const navigateCalendarMonth = (direction) => {
    const newMonth = new Date(calendarMonth);
    newMonth.setMonth(newMonth.getMonth() + direction);
    setCalendarMonth(newMonth);
  };

  // Memoize calendar days generation to avoid recalculating on every render
  const generateCalendarDays = useMemo(() => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    
    const days = [];
    
    // Add all days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  }, [calendarMonth]);

  const isDateInRange = (date) => {
    if (!startDate || !endDate) return false;
    const dateStr = formatDateLocal(date);
    return dateStr >= startDate && dateStr <= endDate;
  };

  const isDateSelected = (date) => {
    const dateStr = formatDateLocal(date);
    return dateStr === startDate || dateStr === endDate;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSessionList().catch((error) => {
      console.error("Error loading initial data:", error);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSessionList = async () => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getSessionList.php";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    try {
      const response = await axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
        },
      });
      if (response.data.api_status === "OK") {
        const sessionList = response.data.data || [];
        setMSessionList(sessionList);
        
        // Auto-select current session if available
        if (sessionList.length > 0) {
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          
          // Find current session (active or current year)
          let selectedSession = sessionList.find(
            (session) =>
              session.status === "Active" ||
              session.session_name.includes(currentYear.toString())
          );

          // If no current session found, use first session
          if (!selectedSession) {
            selectedSession = sessionList[0];
          }

          handleSessionChange(selectedSession);
        }
      }
    } catch (error) {
      console.error("Error fetching session list:", error);
    }
  };

  // Fetch classes when session is available (for filter dropdown and classWise report)
  // This replaces the separate classWise fetch since classes are needed for filtering anyway
  useEffect(() => {
    const sessionIdToUse = selectedSessionId || SESSION_ID;
    if (sessionIdToUse) {
      // Always fetch classes when session is available (they're used for both filter and classWise)
      getClass(sessionIdToUse);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSessionId, SESSION_ID]);

  // Set "Today" as default when report type changes to dateRange
  useEffect(() => {
    if (reportType === "dateRange" && !dateRangePreset) {
      handleDateRangePreset("today");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType]);

  // Auto-load "today" collection when session is selected
  useEffect(() => {
    if (
      reportType === "today" &&
      SESSION_ID
    ) {
      setFileUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID]);

  //Created By Cursor — Auto-load "As On Date" (session start → today)
  useEffect(() => {
    if (reportType === "asOnDate" && SESSION_ID) {
      const bounds = resolveAsOnDateBounds();
      if (bounds.from && bounds.to) {
        setStartDate(bounds.from);
        setEndDate(bounds.to);
        setFileUrl();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID, sessionStartDate]);

  // Auto-load "dateRange" when both dates are selected
  useEffect(() => {
    if (
      reportType === "dateRange" &&
      SESSION_ID &&
      startDate &&
      endDate
    ) {
      setFileUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID, startDate, endDate]);

  // Don't auto-load for month - user must explicitly select a month

  const fetchFeeCollectionBatch = async (overrideMonth = null, overrideClassId = null, overrideSectionId = null) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getFeeCollectionBatch.php";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    // Use != null so explicit `undefined` (e.g. missing item.section_id in overrides) falls back to state
    const classIdToUse = overrideClassId != null ? overrideClassId : CLASS_ID;
    const sectionIdToUse = overrideSectionId != null ? overrideSectionId : SECTION_ID;

    if (!SESSION_ID) {
      myToast.notify_warning("Please ensure session is set");
      return;
    }

    if (reportType === "classWise") {
      const cid = String(classIdToUse ?? "").trim();
      const sid = String(sectionIdToUse ?? "").trim();
      if (!cid || !sid) {
        myToast.notify_warning(
          "Both class and section are required — choose a class–section card below."
        );
        return;
      }
    }

    const params = {
      school_code: SCHOOL_CODE,
      session_id: SESSION_ID,
    };

    if (reportType === "today") {
      const today = new Date();
      params.report_type = "today";
      params.date = formatDateLocal(today);
    } else if (reportType === "asOnDate") {
      //Created By Cursor
      const bounds = resolveAsOnDateBounds();
      if (!bounds.from || !bounds.to) {
        myToast.notify_warning("Session start date is missing");
        return;
      }
      params.report_type = "as_on_date";
      params.start_date = bounds.from;
      params.end_date = bounds.to;
    } else if (reportType === "dateRange") {
      if (!startDate || !endDate) {
        myToast.notify_warning("Please select both start and end dates");
        return;
      }
      params.report_type = "date_range";
      params.start_date = startDate;
      params.end_date = endDate;
    } else if (reportType === "classWise") {
      params.report_type = "class_wise";
      params.class_id = classIdToUse;
      params.section_id = sectionIdToUse || "";
    } else {
      const monthToUse = overrideMonth != null ? overrideMonth : selectedOption;
      if (!monthToUse) {
        myToast.notify_warning("Please select month");
        return;
      }
      params.report_type = "month";
      params.year_month = monthToUse;
    }

    setFeeBatchLoading(true);
    setShowPreview(true);
    try {
      const response = await axios.get(URL, { params });
      if (response.data.api_status === "OK") {
        const rows = response.data.data || [];
        const sessionNameCache = response.data.sessionNameCache || {};
        const classInfoCache = response.data.classInfoCache || {};

        // Enrich rows with display fields coming from caches
        const enriched = rows.map((r) => {
          const sid = r.session_id || SESSION_ID;
          const cacheKey = `${r.student_id || ""}_${sid || ""}`;
          return {
            ...r,
            session_name: sessionNameCache[sid] || r.session_name || "",
            class_name: classInfoCache[cacheKey] || r.class_name || "",
          };
        });

        setMFeeCollectionBatch(enriched);
      } else {
        setMFeeCollectionBatch([]);
        myToast.notify_warning(response.data.api_remark || "Failed to load fee collection");
      }
    } catch (error) {
      console.error("Error fetching fee collection batch:", error);
      setMFeeCollectionBatch([]);
      myToast.notify_error("Failed to load fee collection");
    } finally {
      setFeeBatchLoading(false);
    }
  };

  // Call getClassList when board and medium are selected and class data is available
  useEffect(() => {
    if (selectedBoardId && selectedMediumId && mClassData.length > 0) {
      getClassList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBoardId, selectedMediumId, mClassData]);

  const handleSessionChange = (session) => {
    if (!session) return;
    
    setSESSION_ID(session.session_id);
    setSelectedSessionId(session.session_id);
    setSelectedSessionName(session.session_name);
    setSelectedSessionStatus(session.status || "");
    setSelectedOption(""); // Reset month selection
    setSessionStartDate(session.start_date || session.startDate || "");

    // Clear class-related state when session changes
    setMClassData([]);
    setMFilteredClassSectionList([]);
    setClassBoard([]);
    setClassMedium([]);
    setSelectedBoardId("");
    setSelectedMediumId("");
    setCLASS_ID("");
    setSECTION_ID("");
    setCLASS_SECTION_NAME("");
    setSELECTED_CLASS_POSITION(-1);

    // Generate month options from session start to end date
    if (session.start_date && session.end_date) {
      const start_date = new Date(session.start_date);
      const end_date = new Date(session.end_date);
      const mYearMonth = [];
      while (start_date <= end_date) {
        const year = start_date.getFullYear();
        const month = String(start_date.getMonth() + 1).padStart(2, "0");
        mYearMonth.push(`${year}-${month}`);
        start_date.setMonth(start_date.getMonth() + 1);
      }
      setMOptions(mYearMonth);
      
      // Don't auto-select current month - let user choose
    }

    // Classes will be automatically fetched by the useEffect when selectedSessionId changes
  };

  const getClass = async (session_id) => {
    if (!session_id) return;
    
    try {
      setLoading(true);
      // Clear previous class data before fetching new data
      setMClassData([]);
      setMFilteredClassSectionList([]);
      setClassBoard([]);
      setClassMedium([]);
      setSelectedBoardId("");
      setSelectedMediumId("");
      
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const FUNCTION_NAME = "getClass.php";
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

      const response = await axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: session_id,
        },
      });

      if (response.data.api_status === "OK") {
        const classData = response.data.data.class || [];
        const boardData = response.data.data.board || [];
        const mediumData = response.data.data.medium || [];
        
        setMClassData(classData);
        setClassBoard(boardData);
        setClassMedium(mediumData);

        // Auto-select first board and medium
        if (boardData.length > 0 && mediumData.length > 0) {
          setSelectedBoardId(boardData[0].board_id);
          setSelectedMediumId(mediumData[0].medium_id);
          // getClassList will be called by useEffect when selectedBoardId, selectedMediumId, and mClassData are set
        }
      } else {
        myToast.notify_warning(response.data.api_remark || "Failed to load classes");
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
      myToast.notify_error("Failed to load classes");
    } finally {
      setLoading(false);
    }
  };

  const getClassList = () => {
    if (!selectedBoardId || !selectedMediumId) return;

    let filtered = [];
    let mFilteredClassList = [];

    // Filter classes by board and medium
    for (let item of mClassData) {
      if (item.board_id === selectedBoardId && item.medium_id === selectedMediumId) {
        mFilteredClassList.push(item);
      }
    }

    // Process sections
    for (let item of mFilteredClassList) {
      if (item.section === "No") {
        item["section_id"] = "No";
        filtered.push(item);
      } else {
        for (let section of item.section) {
          section["board_id"] = selectedBoardId;
          section["board_name"] = item.board_name;
          section["medium_id"] = selectedMediumId;
          section["medium_name"] = item.medium_name;
          filtered.push(section);
        }
      }
    }

    setMFilteredClassSectionList(filtered);
  };

  // Process all classes for filter dropdown (all boards and mediums)
  const processFilterClassList = () => {
    if (!mClassData || mClassData.length === 0) {
      setFilterClassList([]);
      return;
    }

    let allClasses = [];

    // Process all classes regardless of board/medium
    for (let item of mClassData) {
      if (item.section === "No" || !item.section) {
        // Class without sections
        allClasses.push({
          value: `${item.class_id}_No`,
          label: item.class_name || "",
          class_id: item.class_id,
          section_id: "No",
        });
      } else if (Array.isArray(item.section)) {
        // Class with sections
        for (let section of item.section) {
          const sectionId = section.section_id || "No";
          const sectionName = section.section_name || "";
          const className = item.class_name || "";
          allClasses.push({
            value: `${item.class_id}_${sectionId}`,
            label: sectionName ? `${className} - ${sectionName}` : className,
            class_id: item.class_id,
            section_id: sectionId,
          });
        }
      }
    }

    setFilterClassList(allClasses);
  };

  // Update filter class list when mClassData changes
  useEffect(() => {
    processFilterClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mClassData]);

  const handleSelectedSession = (session_id, session_name, session_status, start_date, end_date) => {
    const session = {
      session_id,
      session_name,
      status: session_status,
      start_date,
      end_date,
    };
    handleSessionChange(session);
    setIsOpenSessionDialog(false);
  };

  const getCurrentYearMonth = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const CallBackClassSelect = (
    class_id,
    section_id,
    session_id,
    selected_position,
    class_name,
    section_name,
    session_name,
    start_date,
    end_date
  ) => {
    setCLASS_ID(class_id);
    setSECTION_ID(section_id);
    setSESSION_ID(session_id);
    setCLASS_SECTION_NAME(section_id === "No" ? class_name : `${class_name}:${section_name}`);
    setSELECTED_CLASS_POSITION(selected_position);
    
    // Update month options based on selected session
    if (start_date && end_date) {
      const start = new Date(start_date);
      const end = new Date(end_date);
      const mYearMonth = [];
      while (start <= end) {
        const year = start.getFullYear();
        const month = String(start.getMonth() + 1).padStart(2, "0");
        mYearMonth.push(`${year}-${month}`);
        start.setMonth(start.getMonth() + 1);
      }
      setMOptions(mYearMonth);
    }
  };

  const setFileUrl = (overrideMonth = null, overrideClassId = null, overrideSectionId = null) =>
    fetchFeeCollectionBatch(overrideMonth, overrideClassId, overrideSectionId);

  const selectableTxnRows = useMemo(
    () =>
      (mFeeCollectionBatchFilteredSorted || []).filter((r) =>
        String(r.transaction_id ?? "").trim()
      ),
    [mFeeCollectionBatchFilteredSorted]
  );

  const selectedTxnIdSet = useMemo(
    () => new Set(selectedTxnIds),
    [selectedTxnIds]
  );

  useEffect(() => {
    const stillInBatch = new Set(
      (mFeeCollectionBatch || [])
        .map((r) => String(r.transaction_id ?? "").trim())
        .filter(Boolean)
    );
    const visible = new Set(
      (mFeeCollectionBatchFilteredSorted || [])
        .map((r) => String(r.transaction_id ?? "").trim())
        .filter(Boolean)
    );
    setSelectedTxnIds((ids) =>
      ids.filter((id) => stillInBatch.has(id) && visible.has(id))
    );
  }, [mFeeCollectionBatch, mFeeCollectionBatchFilteredSorted]);

  const allSelectableSelected =
    selectableTxnRows.length > 0 &&
    selectableTxnRows.every((r) =>
      selectedTxnIdSet.has(String(r.transaction_id).trim())
    );

  const toggleSelectAllTxns = () => {
    if (selectableTxnRows.length === 0) return;
    if (allSelectableSelected) setSelectedTxnIds([]);
    else
      setSelectedTxnIds(selectableTxnRows.map((r) => String(r.transaction_id).trim()));
  };

  const toggleTxnRowSelected = (row) => {
    const id = String(row.transaction_id ?? "").trim();
    if (!id) return;
    setSelectedTxnIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleOpenTxnReceipt = (row) => {
    const tid = String(row.transaction_id ?? "").trim();
    const stu = String(row.student_id ?? "").trim();
    const sid = String(row.session_id ?? SESSION_ID ?? "").trim();
    if (!tid || !stu || !sid) {
      myToast.notify_warning("Missing data to open receipt");
      return;
    }
    history.push(
      `/AdminMain/FeeReceipt/${encodeURIComponent(tid)}/${encodeURIComponent(stu)}/${encodeURIComponent(sid)}`
    );
  };

  const handleDeleteSelectedTxns = async () => {
    if (selectedTxnIds.length === 0) {
      myToast.notify_warning("Select one or more transactions");
      return;
    }
    if (
      !window.confirm(
        `Delete ${selectedTxnIds.length} transaction(s)? This cannot be undone.`
      )
    )
      return;
    const staff = SessionManager.getStaffDetails();
    if (!staff?.staff_id) {
      myToast.notify_error("Staff login required");
      return;
    }
    const school = SessionManager.getSchoolCode();
    if (!school) {
      myToast.notify_error("School code missing");
      return;
    }
    setTxnActionLoading(true);
    let ok = 0;
    let fail = 0;
    try {
      //Created By Cursor — O(1) row lookup + single bulk API call
      const byId = new Map();
      for (const r of mFeeCollectionBatch || []) {
        const id = String(r.transaction_id ?? "").trim();
        if (id) byId.set(id, r);
      }
      const transactions = [];
      for (const tid of selectedTxnIds) {
        const row = byId.get(tid);
        if (!row) {
          fail++;
          continue;
        }
        transactions.push({
          transaction_id: row.transaction_id,
          transaction_amount: row.paid_amount,
          student_id: row.student_id,
          transaction_for: row.transaction_for || "FEE",
          session_id: row.session_id || SESSION_ID,
        });
      }
      if (transactions.length === 0) {
        myToast.notify_error("Could not delete selected transactions");
      } else {
        const FUNCTION_NAME = "deleteMultipleTransaction.php";
        const baseUrl = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;
        try {
          const res = await axios.post(
            baseUrl,
            {
              staff_id: staff.staff_id,
              school_code: school,
              transactions,
            },
            {
              headers: { "Content-Type": "application/json" },
              timeout: 120000,
            }
          );
          ok = Number(res.data?.deleted) || 0;
          fail += Number(res.data?.failed) || 0;
          const status = res.data?.api_status;
          if (status === "ERROR" && ok === 0) {
            myToast.notify_error(
              res.data?.api_remark || "Could not delete selected transactions"
            );
          } else if (ok > 0) {
            myToast.notify_success(
              `${ok} deleted${fail ? `, ${fail} failed` : ""}`
            );
          }
        } catch (err) {
          console.error("[TransactionPanel] bulk delete error", err);
          myToast.notify_error("Could not delete selected transactions");
        }
      }
      setSelectedTxnIds([]);
      setFileUrl();
    } finally {
      setTxnActionLoading(false);
    }
  };

  const renderTxnBatchToolbarBody = (showTotal = true) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: showTotal ? "space-between" : "flex-end",
        flexWrap: "wrap",
        gap: "12px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "700",
            color: "rgba(255, 255, 255, 0.95)",
          }}
        >
          {selectedTxnIds.length} selected
        </span>
        <button
          type="button"
          disabled={
            selectedTxnIds.length === 0 || txnActionLoading || feeBatchLoading
          }
          onClick={handleDeleteSelectedTxns}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 14px",
            fontSize: "13px",
            fontWeight: "700",
            borderRadius: "10px",
            border: "1px solid rgba(254, 226, 226, 0.95)",
            background: "linear-gradient(180deg, #ffffff 0%, #fef2f2 100%)",
            color: "#dc2626",
            cursor:
              selectedTxnIds.length === 0 || txnActionLoading || feeBatchLoading
                ? "not-allowed"
                : "pointer",
            opacity:
              selectedTxnIds.length === 0 || txnActionLoading || feeBatchLoading
                ? 0.5
                : 1,
          }}
        >
          <i className="fa fa-trash" aria-hidden="true" />
          {txnActionLoading ? "Deleting…" : "Delete selected"}
        </button>
      </div>
      {showTotal && (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "14px",
            flexWrap: "wrap",
            marginLeft: "auto",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontWeight: "800",
              color: "#ffffff",
            }}
          >
            Total
          </span>
          <span
            style={{
              fontSize: "15px",
              fontWeight: "900",
              color: "#ffffff",
              whiteSpace: "nowrap",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            ₹{" "}
            {feeBatchTotalPaid.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
      )}
    </div>
  );

  // Early returns
  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
      <div className="content" style={{ background: COLORS.whitesmoke, paddingLeft: "20px", paddingRight: "20px" }}>
        <div className="content-header">
          <div className="leftside-content-header">
            <ul className="breadcrumbs">
              <li>
                <i className="fa fa-home" aria-hidden="true" />
                <span>Transport Panel</span>
              </li>
            </ul>
          </div>
          <div className="rightside-content-header">
            <BackButton onClick={() => history.goBack()} />
          </div>
        </div>

        <div
          className="animated fadeInUp bg_page_white_rounded box_shadow"
          style={{ marginTop: "20px", paddingLeft: "10px", paddingRight: "10px", paddingBottom: "30px" }}
        >
          <>
            {/* Session Selection & Report Type - Combined */}
              <div
                style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  borderRadius: "16px",
                  padding: "0",
                  marginBottom: "20px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
                  border: "2px solid #e5e7eb",
                  overflow: "hidden",
                }}
              >
                {/* Session Selection */}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpenSessionDialog(true);
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={{
                      background: `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                      borderRadius: "0",
                      padding: "12px 20px",
                      marginBottom: "0",
                      boxShadow: "none",
                      border: "none",
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      borderBottom: "2px solid rgba(255, 255, 255, 0.1)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-1px) scale(1.005)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <i
                          className="fa fa-calendar"
                          style={{
                            fontSize: "20px",
                            color: "#ffffff",
                            opacity: 0.9,
                          }}
                        ></i>
                        <div>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              fontWeight: "700",
                              color: "#ffffff",
                              lineHeight: "1.4",
                            }}
                          >
                            {selectedSessionName || "Select Session"}
                          </p>
                          {selectedSessionStatus && (
                            <p
                              style={{
                                margin: "2px 0 0 0",
                                fontSize: "12px",
                                color: "rgba(255, 255, 255, 0.85)",
                                fontWeight: "500",
                              }}
                            >
                              Status: {selectedSessionStatus}
                            </p>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "40px",
                          borderRadius: "10px",
                          background: "rgba(255, 255, 255, 0.2)",
                          transition: "all 0.3s ease",
                        }}
                      >
                        <i
                          className="fa fa-chevron-right"
                          style={{
                            fontSize: "16px",
                            color: "#ffffff",
                            opacity: 0.9,
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </Link>

                {/* Report Type Selection */}
                <div
                  style={{
                    padding: "12px 16px",
                  }}
                >
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "10px" }}>
                  {[
                    { value: "today", label: "Today Collection", icon: "fa-calendar-day", color: "#10b981" },
                    { value: "asOnDate", label: "As On Date", icon: "fa-history", color: "#06b6d4" },
                    { value: "dateRange", label: "Date Range", icon: "fa-calendar-alt", color: "#3b82f6" },
                    { value: "month", label: "Month Wise", icon: "fa-calendar", color: "#8b5cf6" },
                    { value: "classWise", label: "Class Wise", icon: "fa-users", color: "#f59e0b" },
                  ].map((option) => {
                    const isSelected = reportType === option.value;
                    return (
                      <div
                        key={option.value}
                        onClick={() => {
                          setReportType(option.value);
                          if (option.value === "asOnDate") {
                            const bounds = resolveAsOnDateBounds();
                            setStartDate(bounds.from);
                            setEndDate(bounds.to);
                            setDateRangePreset("");
                          }
                          // Clear preview when switching to monthWise or classWise
                          if (option.value === "month" || option.value === "classWise") {
                            setShowPreview(false);
                            setMFeeCollectionBatch([]);
                            // Clear month selection for monthWise
                            if (option.value === "month") {
                              setSelectedOption("");
                            }
                            // Do not clear class/section when switching to class-wise — board/medium
                            // may look "default" but a card click is what sets CLASS_ID/SECTION_ID;
                            // clearing here made a valid selection disappear when toggling report types.
                          }
                        }}
                        style={{
                          padding: "10px 12px",
                          borderRadius: "10px",
                          border: isSelected
                            ? `2px solid ${option.color}`
                            : "2px solid #e5e7eb",
                          background: isSelected
                            ? `linear-gradient(135deg, ${option.color}15 0%, ${option.color}08 100%)`
                            : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                          cursor: "pointer",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                          boxShadow: isSelected
                            ? `0 4px 12px ${option.color}30, 0 2px 4px rgba(0, 0, 0, 0.1)`
                            : "0 2px 4px rgba(0, 0, 0, 0.05)",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                            e.currentTarget.style.borderColor = "#cbd5e1";
                            e.currentTarget.style.transform = "translateY(-1px)";
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                            e.currentTarget.style.borderColor = "#e5e7eb";
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "8px",
                              background: isSelected
                                ? `linear-gradient(135deg, ${option.color} 0%, ${option.color}dd 100%)`
                                : `linear-gradient(135deg, ${option.color}20 0%, ${option.color}10 100%)`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <i
                              className={`fa ${option.icon}`}
                              style={{
                                fontSize: "16px",
                                color: isSelected ? "#ffffff" : option.color,
                              }}
                            ></i>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: isSelected ? "700" : "600",
                                color: isSelected ? option.color : "#374151",
                              }}
                            >
                              {option.label}
                            </div>
                          </div>
                          {isSelected && (
                            <i
                              className="fa fa-check-circle"
                              style={{
                                fontSize: "18px",
                                color: option.color,
                              }}
                            ></i>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                </div>
              </div>

              {/* Session Selection Modal */}
              {isOpenSessionDialog && (
                <MdlSelectSession
                  action={() => setIsOpenSessionDialog(false)}
                  action2={handleSelectedSession}
                />
              )}

              {/* Today Collection Section */}
              {reportType === "today" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-calendar-day" style={{ color: "#10b981", fontSize: "16px" }}></i>
                    Today's Collection
                  </h5>
                  <div
                    style={{
                      padding: "12px",
                      background: "#ecfdf5",
                      borderRadius: "8px",
                      border: "1px solid #86efac",
                    }}
                  >
                    <i className="fa fa-info-circle me-2" style={{ color: "#10b981" }}></i>
                    <span style={{ color: "#047857", fontWeight: "600", fontSize: "14px" }}>
                      Report will be generated for today's collection: {new Date().toLocaleDateString()}
                    </span>
                  </div>
                </div>
              )}

              {/* Created By Cursor — As On Date Section (session start → today) */}
              {reportType === "asOnDate" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-history" style={{ color: "#06b6d4", fontSize: "16px" }}></i>
                    As On Date
                  </h5>
                  <div
                    style={{
                      padding: "12px",
                      background: "#ecfeff",
                      borderRadius: "8px",
                      border: "1px solid #67e8f9",
                    }}
                  >
                    <i className="fa fa-info-circle me-2" style={{ color: "#06b6d4" }}></i>
                    <span style={{ color: "#0e7490", fontWeight: "600", fontSize: "14px" }}>
                      Report includes all collection from session start
                      {sessionStartDate
                        ? ` (${parseLooseDate(sessionStartDate)?.toLocaleDateString?.() || sessionStartDate})`
                        : ""}{" "}
                      to today ({new Date().toLocaleDateString()}).
                    </span>
                  </div>
                </div>
              )}

              {/* Date Range Section */}
              {reportType === "dateRange" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "12px 16px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-calendar-alt" style={{ color: "#3b82f6", fontSize: "16px" }}></i>
                    Date Range Selection
                  </h5>
                  
                  {/* Quick Date Range Buttons - Modern */}
                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ 
                      display: "grid", 
                      gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", 
                      gap: "8px" 
                    }}>
                      {[
                        { value: "today", label: "Today", icon: "fa-calendar-day", color: "#10b981" },
                        { value: "yesterday", label: "Yesterday", icon: "fa-calendar-minus", color: "#6366f1" },
                        { value: "thisWeek", label: "This Week", icon: "fa-calendar-week", color: "#3b82f6" },
                        { value: "lastWeek", label: "Last Week", icon: "fa-calendar-week", color: "#a855f7" },
                        { value: "last7Days", label: "Last 7 Days", icon: "fa-calendar", color: "#8b5cf6" },
                        { value: "thisMonth", label: "This Month", icon: "fa-calendar-alt", color: "#f59e0b" },
                        { value: "lastMonth", label: "Last Month", icon: "fa-calendar-check", color: "#ef4444" },
                        { value: "last30Days", label: "Last 30 Days", icon: "fa-calendar", color: "#06b6d4" },
                      ].map((preset) => {
                        const isSelected = dateRangePreset === preset.value;
                        return (
                          <button
                            key={preset.value}
                            type="button"
                            onClick={() => handleDateRangePreset(preset.value)}
                            style={{
                              padding: "10px 12px",
                              fontSize: "12px",
                              fontWeight: isSelected ? "700" : "600",
                              borderRadius: "10px",
                              border: isSelected
                                ? `2px solid ${preset.color}`
                                : "2px solid #e5e7eb",
                              background: isSelected
                                ? `linear-gradient(135deg, ${preset.color} 0%, ${preset.color}dd 100%)`
                                : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              color: isSelected ? "#ffffff" : "#374151",
                              cursor: "pointer",
                              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              boxShadow: isSelected
                                ? `0 4px 12px ${preset.color}40, 0 2px 4px rgba(0, 0, 0, 0.1)`
                                : "0 2px 4px rgba(0, 0, 0, 0.05)",
                              transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                              whiteSpace: "nowrap",
                            }}
                            onMouseEnter={(e) => {
                              if (!isSelected) {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${preset.color}15 0%, ${preset.color}08 100%)`;
                                e.currentTarget.style.borderColor = preset.color;
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = `0 4px 12px ${preset.color}30, 0 2px 4px rgba(0, 0, 0, 0.1)`;
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isSelected) {
                                e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                                e.currentTarget.style.borderColor = "#e5e7eb";
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }
                            }}
                          >
                            <div style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "6px",
                              background: isSelected
                                ? "rgba(255, 255, 255, 0.2)"
                                : `${preset.color}15`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.3s ease",
                              flexShrink: 0,
                            }}>
                              <i 
                                className={`fa ${preset.icon}`} 
                                style={{ 
                                  fontSize: "12px",
                                  color: isSelected ? "#ffffff" : preset.color
                                }}
                              ></i>
                            </div>
                            <span style={{ flex: 1, textAlign: "left", whiteSpace: "nowrap" }}>{preset.label}</span>
                            {isSelected && (
                              <i 
                                className="fa fa-check-circle" 
                                style={{ 
                                  fontSize: "12px",
                                  color: "#ffffff",
                                  flexShrink: 0,
                                }}
                              ></i>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Calendar View */}
                  <div>
                    {showCalendar && (
                      <div
                        style={{
                          background: "#ffffff",
                          borderRadius: "12px",
                          border: "2px solid #e5e7eb",
                          padding: "8px 10px",
                          marginBottom: "20px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                        }}
                      >
                        {/* Calendar Header - Compact */}
                        <div style={{ 
                          display: "flex", 
                          justifyContent: "space-between", 
                          alignItems: "center", 
                          marginBottom: "8px",
                          background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                          padding: "8px 12px",
                          borderRadius: "10px",
                          border: "1px solid #bfdbfe"
                        }}>
                          <button
                            type="button"
                            onClick={() => navigateCalendarMonth(-1)}
                            style={{
                              padding: "4px 8px",
                              borderRadius: "6px",
                              border: "1px solid #93c5fd",
                              background: "#ffffff",
                              cursor: "pointer",
                              fontSize: "12px",
                              color: "#374151",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f3f4f6";
                              e.currentTarget.style.borderColor = "#60a5fa";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#ffffff";
                              e.currentTarget.style.borderColor = "#93c5fd";
                            }}
                          >
                            <i className="fa fa-chevron-left"></i>
                          </button>
                          <h6 style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            fontWeight: "700", 
                            color: "#1e40af"
                          }}>
                            {calendarMonth.toLocaleString("default", { month: "short", year: "numeric" })}
                          </h6>
                          <button
                            type="button"
                            onClick={() => navigateCalendarMonth(1)}
                            style={{
                              padding: "4px 8px",
                              borderRadius: "6px",
                              border: "1px solid #93c5fd",
                              background: "#ffffff",
                              cursor: "pointer",
                              fontSize: "12px",
                              color: "#374151",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f3f4f6";
                              e.currentTarget.style.borderColor = "#60a5fa";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#ffffff";
                              e.currentTarget.style.borderColor = "#93c5fd";
                            }}
                          >
                            <i className="fa fa-chevron-right"></i>
                          </button>
                        </div>

                        {/* Calendar - Single Row with 100% Width */}
                        <div style={{ width: "100%", overflowX: "hidden" }}>
                          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            {/* Weekday Headers - Single Row */}
                            <div style={{ 
                              display: "flex", 
                              gap: "1px", 
                              marginBottom: "3px", 
                              width: "100%"
                            }}>
                              {generateCalendarDays.map((date, index) => {
                                const dayIndex = date.getDay();
                                const dayNames = ["S", "M", "T", "W", "T", "F", "S"];
                                const totalDays = generateCalendarDays.length;
                                return (
                                  <div
                                    key={`header-${index}`}
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      color: "#475569",
                                      padding: "4px 1px",
                                      flex: "1",
                                      minWidth: 0,
                                      height: "24px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {dayNames[dayIndex]}
                                  </div>
                                );
                              })}
                            </div>

                            {/* Calendar Days - Single Row */}
                            <div style={{ display: "flex", gap: "1px", width: "100%" }}>
                              {generateCalendarDays.map((date, index) => {
                                const dateStr = formatDateLocal(date);
                                const isInRange = isDateInRange(date);
                                const isSelected = isDateSelected(date);
                                const isTodayDate = isToday(date);
                                const isStartDate = dateStr === startDate;
                                const isEndDate = dateStr === endDate;
                                const isCurrentMonth = date.getMonth() === calendarMonth.getMonth();

                                return (
                                  <button
                                    key={dateStr}
                                    type="button"
                                    onClick={() => handleCalendarDateClick(date)}
                                    style={{
                                      padding: "4px 1px",
                                      fontSize: "12px",
                                      fontWeight: isSelected ? "700" : "500",
                                      borderRadius: "50%",
                                      border: isSelected
                                        ? "2px solid #3b82f6"
                                        : isInRange
                                        ? "1px solid #bfdbfe"
                                        : "1px solid transparent",
                                      background: isStartDate || isEndDate
                                        ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
                                        : isInRange
                                        ? "#eff6ff"
                                        : isTodayDate
                                        ? "#fef3c7"
                                        : !isCurrentMonth
                                        ? "#e5e7eb"
                                        : "#e2e8f0",
                                      color: isStartDate || isEndDate
                                        ? "#ffffff"
                                        : isTodayDate && !isInRange
                                        ? "#92400e"
                                        : !isCurrentMonth
                                        ? "#9ca3af"
                                        : "#374151",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      position: "relative",
                                      minHeight: "32px",
                                      flex: "1",
                                      minWidth: 0,
                                      aspectRatio: "1",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (!isSelected && !isInRange && !isTodayDate) {
                                        e.currentTarget.style.background = "#f1f5f9";
                                        e.currentTarget.style.borderColor = "#cbd5e1";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (!isSelected && !isInRange && !isTodayDate) {
                                        e.currentTarget.style.background = !isCurrentMonth 
                                          ? "#e5e7eb" 
                                          : "#e2e8f0";
                                        e.currentTarget.style.borderColor = "transparent";
                                      }
                                    }}
                                    title={`${date.toLocaleDateString()}`}
                                  >
                                    <div style={{ fontSize: "13px", lineHeight: "1.3", fontWeight: "600" }}>{date.getDate()}</div>
                                    {date.getDate() === 1 && (
                                      <div style={{ fontSize: "9px", color: "#9ca3af", marginTop: "2px", fontWeight: "500" }}>
                                        {date.toLocaleString("default", { month: "short" }).substring(0, 3)}
                                      </div>
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Custom Date Range Inputs */}
                    <div style={{ marginTop: "20px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: "1", minWidth: "200px" }}>
                          <label style={{ fontWeight: "600", fontSize: "14px", color: "#374151", margin: 0, whiteSpace: "nowrap" }}>
                            Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              setDateRangePreset("custom");
                            }}
                            style={{
                              padding: "10px 14px",
                              fontSize: "14px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              border: "2px solid #e5e7eb",
                              cursor: "pointer",
                              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              color: "#374151",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                              flex: 1,
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#3b82f6";
                              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(59, 130, 246, 0.15)";
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5e7eb";
                              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.target.style.transform = "translateY(0)";
                            }}
                            onMouseEnter={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#93c5fd";
                                e.target.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.1)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#e5e7eb";
                                e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: "1", minWidth: "200px" }}>
                          <label style={{ fontWeight: "600", fontSize: "14px", color: "#374151", margin: 0, whiteSpace: "nowrap" }}>
                            End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              setDateRangePreset("custom");
                            }}
                            min={startDate}
                            style={{
                              padding: "10px 14px",
                              fontSize: "14px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              border: "2px solid #e5e7eb",
                              cursor: "pointer",
                              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              color: "#374151",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                              flex: 1,
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#3b82f6";
                              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(59, 130, 246, 0.15)";
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5e7eb";
                              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.target.style.transform = "translateY(0)";
                            }}
                            onMouseEnter={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#93c5fd";
                                e.target.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.1)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#e5e7eb";
                                e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }
                            }}
                          />
                        </div>
                      </div>
                      {startDate && endDate && (
                        <div style={{ marginTop: "12px", padding: "10px", background: "#eff6ff", borderRadius: "8px", border: "1px solid #bfdbfe" }}>
                          <i className="fa fa-info-circle me-2" style={{ color: "#3b82f6" }}></i>
                          <span style={{ color: "#1e40af", fontWeight: "500", fontSize: "13px" }}>
                            Selected: {new Date(startDate).toLocaleDateString()} - {new Date(endDate).toLocaleDateString()}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Month Wise Section */}
              {reportType === "month" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                    overflow: "hidden",
                  }}
                >
                  {/* Month Selection */}
                  {mOptions.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "nowrap", gap: "10px", overflowX: "auto", padding: "4px", margin: "-4px" }}>
                    {mOptions.map((option) => {
                      const isSelected = selectedOption === option;
                      // Format month display: Convert YYYY-MM to readable format
                      const date = new Date(option + "-01");
                      const monthName = date.toLocaleString("default", { month: "long" });
                      
                      return (
                        <label
                          key={option}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px 12px",
                            borderRadius: "10px",
                            background: isSelected
                              ? "linear-gradient(135deg, #8b5cf620 0%, #8b5cf610 100%)"
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            border: isSelected
                              ? "2px solid #8b5cf6"
                              : "2px solid #e5e7eb",
                            cursor: "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            fontSize: "13px",
                            fontWeight: isSelected ? "700" : "600",
                            color: isSelected ? "#8b5cf6" : "#64748b",
                            boxShadow: isSelected
                              ? "0 4px 12px rgba(139, 92, 246, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)"
                              : "0 2px 4px rgba(0, 0, 0, 0.05)",
                            transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                            minWidth: "80px",
                            flexShrink: 0,
                            boxSizing: "border-box",
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                              e.currentTarget.style.borderColor = "#cbd5e1";
                              e.currentTarget.style.transform = "translateY(-1px)";
                              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                            } else {
                              e.currentTarget.style.transform = "translateY(-3px)";
                              e.currentTarget.style.boxShadow = "0 6px 16px rgba(139, 92, 246, 0.3), 0 4px 8px rgba(0, 0, 0, 0.12)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                              e.currentTarget.style.borderColor = "#e5e7eb";
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            } else {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 4px 12px rgba(139, 92, 246, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)";
                            }
                          }}
                        >
                          <input
                            type="radio"
                            name="monthSelection"
                            checked={isSelected}
                            onChange={() => {
                              setSelectedOption(option);
                              // Load report when user explicitly selects a month
                              // Pass the selected option directly to avoid stale state
                              if (SESSION_ID) {
                                setFileUrl(option);
                              }
                            }}
                            style={{
                              width: "16px",
                              height: "16px",
                              cursor: "pointer",
                              accentColor: "#8b5cf6",
                            }}
                          />
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", lineHeight: "1.3" }}>
                            <span>{monthName}</span>
                            <span style={{ fontSize: "11px", opacity: 0.8 }}>({option})</span>
                          </div>
                        </label>
                      );
                    })}
                    </div>
                  )}
                  {mOptions.length === 0 && selectedSessionId && (
                    <div style={{ padding: "12px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
                      <i className="fa fa-info-circle me-2" style={{ color: "#f59e0b" }}></i>
                      <span style={{ color: "#92400e", fontWeight: "500", fontSize: "13px" }}>
                        No months available for the selected session. Please check session dates.
                      </span>
                    </div>
                  )}
                </div>
              )}

              {/* Class Wise Section */}
              {reportType === "classWise" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "12px 16px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "8px", fontSize: "14px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-users" style={{ color: "#f59e0b", fontSize: "14px" }}></i>
                    Class Selection
                  </h5>
                  
                  {!selectedSessionId ? (
                    <div style={{ padding: "10px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
                      <i className="fa fa-info-circle me-2" style={{ color: "#f59e0b" }}></i>
                      <span style={{ color: "#92400e", fontWeight: "500", fontSize: "13px" }}>
                        Please select a session first
                      </span>
                    </div>
                  ) : (
                    <>
                      {/* Board and Medium Selectors */}
                      <div style={{
                        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        borderRadius: "10px",
                        padding: "6px 12px",
                        marginBottom: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)",
                        border: "2px solid #e5e7eb",
                      }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "10px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "700", color: "#111827", marginBottom: 0, display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
                              <i className="fa fa-graduation-cap" style={{ color: COLORS.primary_color_shade5 || "#3b82f6", fontSize: "12px" }}></i>
                              Select Board:
                            </label>
                            <select
                              style={{
                                width: "100%",
                                padding: "6px 10px",
                                fontSize: "12px",
                                borderRadius: "8px",
                                border: "2px solid #e5e7eb",
                                background: "#ffffff",
                                fontWeight: "600",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                outline: "none",
                                cursor: "pointer",
                                flex: 1,
                              }}
                              value={selectedBoardId}
                              onChange={(e) => {
                                const boardId = e.target.selectedOptions[0].getAttribute("board_id");
                                setSelectedBoardId(boardId);
                                getClassList();
                              }}
                            >
                              {classBoard.map((item, index) => (
                                <option key={index} board_id={item.board_id} value={item.board_id}>
                                  {item.board_name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "700", color: "#111827", marginBottom: 0, display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
                              <i className="fa fa-book" style={{ color: COLORS.primary_color_shade5 || "#3b82f6", fontSize: "12px" }}></i>
                              Select Medium:
                            </label>
                            <select
                              style={{
                                width: "100%",
                                padding: "6px 10px",
                                fontSize: "12px",
                                borderRadius: "8px",
                                border: "2px solid #e5e7eb",
                                background: "#ffffff",
                                fontWeight: "600",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                outline: "none",
                                cursor: "pointer",
                                flex: 1,
                              }}
                              value={selectedMediumId}
                              onChange={(e) => {
                                const mediumId = e.target.selectedOptions[0].getAttribute("medium_id");
                                setSelectedMediumId(mediumId);
                                getClassList();
                              }}
                            >
                              {classMedium.map((item, index) => (
                                <option key={index} medium_id={item.medium_id} value={item.medium_id}>
                                  {item.medium_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Class/Section Cards */}
                      {mFilteredClassSectionList.length > 0 && (
                        <div style={{
                          background: "transparent",
                          borderRadius: "0",
                          padding: "4px 0",
                        }}>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: "6px" }}>
                            {mFilteredClassSectionList.map((item, index) => {
                              const isSelected = SELECTED_CLASS_POSITION === index;
                              return (
                                <div
                                  key={index}
                                  style={{
                                    padding: "12px 12px",
                                    borderRadius: "10px",
                                    minHeight: "48px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: isSelected
                                      ? `2px solid ${COLORS.primary_color_shade5 || "#3b82f6"}`
                                      : "2px solid #e5e7eb",
                                    background: isSelected
                                      ? `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"}20 0%, ${COLORS.primary_color_shade5 || "#3b82f6"}10 100%)`
                                      : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                    cursor: "pointer",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    textAlign: "center",
                                    boxShadow: isSelected
                                      ? `0 4px 12px ${(COLORS.primary_color_shade5 || "#3b82f6")}25, 0 2px 4px rgba(0, 0, 0, 0.1)`
                                      : "0 2px 4px rgba(0, 0, 0, 0.05)",
                                    transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                                  }}
                                  onClick={() => {
                                    const sectionIdResolved =
                                      item.section_id != null &&
                                      String(item.section_id).trim() !== ""
                                        ? item.section_id
                                        : "No";
                                    setSELECTED_CLASS_POSITION(index);
                                    CallBackClassSelect(
                                      item.class_id,
                                      sectionIdResolved,
                                      selectedSessionId,
                                      index,
                                      item.class_name,
                                      item.section_name || "",
                                      selectedSessionName,
                                      "",
                                      ""
                                    );
                                    // Load report when user explicitly selects a class
                                    // Pass class_id and section_id directly (same frame as callback; state is async)
                                    if (SESSION_ID) {
                                      setFileUrl(null, item.class_id, sectionIdResolved);
                                    }
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!isSelected) {
                                      e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                                      e.currentTarget.style.borderColor = "#cbd5e1";
                                      e.currentTarget.style.transform = "translateY(-2px)";
                                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!isSelected) {
                                      e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                                      e.currentTarget.style.borderColor = "#e5e7eb";
                                      e.currentTarget.style.transform = "translateY(0)";
                                      e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                                    }
                                  }}
                                >
                                  <p style={{
                                    fontSize: "12px",
                                    fontWeight: isSelected ? "700" : "600",
                                    color: isSelected ? (COLORS.primary_color_shade5 || "#3b82f6") : "#111827",
                                    margin: 0,
                                  }}>
                                    {item.section_id === "No"
                                      ? item.class_name
                                      : `${item.class_name}: ${item.section_name}`}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Filter and Sort Section */}
              {SESSION_ID && (
                <div style={{
                  width: "100%",
                  background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "12px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  padding: "12px",
                  marginBottom: "12px",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                  transition: "all 0.3s ease",
                  boxSizing: "border-box",
                }}>
                  <h5 style={{ 
                    margin: "0 0 10px 0", 
                    fontSize: "16px", 
                    fontWeight: "700", 
                    color: "#1e293b", 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "8px",
                    letterSpacing: "-0.01em",
                  }}>
                    <i className="fa fa-filter" style={{ 
                      color: "#3b82f6", 
                      fontSize: "16px",
                      filter: "drop-shadow(0 1px 2px rgba(59, 130, 246, 0.3))",
                    }}></i>
                    Filter & Sort
                  </h5>
                  
                  <div style={{ 
                    width: "100%",
                    display: "flex", 
                    flexWrap: "nowrap", 
                    gap: "8px", 
                    alignItems: "end",
                    overflowX: "auto",
                    overflowY: "hidden",
                    boxSizing: "border-box",
                  }}>
                    {/* Filter by Class */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Class
                      </label>
                      <select
                        value={filterClass}
                        onChange={(e) => setFilterClass(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Classes</option>
                        {filterClassList.map((classItem, index) => (
                          <option key={index} value={classItem.value}>
                            {classItem.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    {/* Filter by Month */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Month
                      </label>
                      <select
                        value={filterMonth}
                        onChange={(e) => setFilterMonth(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Months</option>
                        {mOptions.map((option) => {
                          const date = new Date(option + "-01");
                          const monthLabel = date.toLocaleString("default", { month: "long", year: "numeric" });
                          return (
                            <option key={option} value={option}>
                              {monthLabel}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    
                    {/* Filter by Session */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Session
                      </label>
                      <select
                        value={filterSession}
                        onChange={(e) => setFilterSession(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Sessions</option>
                        {mSessionList.map((session) => (
                          <option key={session.session_id} value={session.session_id}>
                            {session.session_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    {/* Filter by Type */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Type
                      </label>
                      <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Types</option>
                        <option value="FEE">FEE</option>
                        <option value="OLD_DUE">OLD_DUE</option>
                        <option value="ACCESSORIES">ACCESSORIES</option>
                      </select>
                    </div>
                    
                    {/* Filter by Mode */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Mode
                      </label>
                      <select
                        value={filterMode}
                        onChange={(e) => setFilterMode(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Modes</option>
                        <option value="CASH">CASH</option>
                        <option value="CHEQUE">CHEQUE</option>
                        <option value="ONLINE">ONLINE</option>
                        <option value="UPI">UPI</option>
                      </select>
                    </div>
                    
                    {/* Sort By */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Sort By
                      </label>
                      <select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">Default</option>
                        <option value="student_name">Student Name</option>
                        <option value="roll_no">Roll No</option>
                        <option value="transaction_date">Transaction Date</option>
                        <option value="amount_paid">Amount</option>
                      </select>
                    </div>
                    
                    {/* Sort Order */}
                    <div style={{ flex: "1 1 auto", minWidth: "100px", maxWidth: "120px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Order
                      </label>
                      <select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="ASC">Ascending</option>
                        <option value="DESC">Descending</option>
                      </select>
                    </div>
                    
                    {/* Action Buttons */}
                    <div style={{ 
                      display: "flex", 
                      gap: "6px", 
                      flex: "0 0 auto", 
                      flexWrap: "nowrap",
                      alignItems: "end",
                      whiteSpace: "nowrap",
                    }}>
                      <button
                        type="button"
                        onClick={() => {
                          // Reload the report with current filter/sort values
                          setFileUrl();
                        }}
                        style={{
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                          boxShadow: "0 2px 4px rgba(59, 130, 246, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          flexShrink: 0,
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(59, 130, 246, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseDown={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        onMouseUp={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                      >
                        <i className="fa fa-filter"></i> Apply
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setFilterClass("");
                          setFilterMonth("");
                          setFilterSession("");
                          setFilterType("");
                          setFilterMode("");
                          setSortBy("");
                          setSortOrder("ASC");
                          // Reload the report after clearing filters
                          setTimeout(() => {
                            setFileUrl();
                          }, 100);
                        }}
                        style={{
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          background: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                          boxShadow: "0 2px 4px rgba(100, 116, 139, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          flexShrink: 0,
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(100, 116, 139, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(100, 116, 139, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseDown={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        onMouseUp={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                      >
                        <i className="fa fa-times"></i> Clear
                      </button>
                    </div>
                  </div>
                </div>
              )}

            {/* Preview (API data) */}
            {showPreview && (
              <div
                className="txn-preview-card"
                style={{
                  marginTop: "12px",
                  width: "100%",
                  boxSizing: "border-box",
                  background: "#ffffff",
                  borderRadius: "16px",
                  border: "1px solid rgba(226, 232, 240, 0.65)",
                  overflow: "hidden",
                  boxShadow:
                    "0 1px 2px rgba(15, 23, 42, 0.04), 0 12px 32px rgba(15, 23, 42, 0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "12px",
                    padding: "10px 14px",
                    minHeight: "48px",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.22)",
                    background: `linear-gradient(135deg, #60a5fa 0%, ${COLORS.primary_color_shade5 || "#3b82f6"} 48%, #2563eb 100%)`,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flex: "0 1 auto",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        width: "34px",
                        height: "34px",
                        borderRadius: "10px",
                        background: "rgba(255, 255, 255, 0.22)",
                        border: "1px solid rgba(255, 255, 255, 0.35)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "14px",
                        flexShrink: 0,
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.12)",
                      }}
                    >
                      <i className="fa fa-list-ul" aria-hidden="true" />
                    </span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: "10px",
                        flexWrap: "wrap",
                        lineHeight: 1.25,
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "800",
                          color: "#ffffff",
                          fontSize: "17px",
                          letterSpacing: "-0.02em",
                          textShadow: "0 1px 2px rgba(0, 0, 0, 0.12)",
                        }}
                      >
                        Transaction List
                      </span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "rgba(255, 255, 255, 0.92)",
                          fontWeight: "700",
                        }}
                      >
                        {(mFeeCollectionBatchFilteredSorted || []).length} record
                        {(mFeeCollectionBatchFilteredSorted || []).length !== 1 ? "s" : ""}
                      </span>
                    </div>
                  </div>
                  {feeBatchLoading ? (
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#ffffff",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.12)",
                        marginLeft: "auto",
                      }}
                    >
                      <span
                        style={{
                          width: "16px",
                          height: "16px",
                          border: "2px solid rgba(255,255,255,0.35)",
                          borderTopColor: "#ffffff",
                          borderRadius: "50%",
                          animation: "txn-spin 0.7s linear infinite",
                        }}
                      />
                      Loading...
                    </div>
                  ) : (mFeeCollectionBatch || []).length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        flexWrap: "wrap",
                        gap: "10px",
                        flex: "1 1 auto",
                        minWidth: 0,
                        marginLeft: "auto",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flex: "1 1 200px",
                          minWidth: "160px",
                          maxWidth: "360px",
                        }}
                      >
                        <i
                          className="fa fa-search"
                          style={{
                            color: "rgba(255, 255, 255, 0.9)",
                            fontSize: "13px",
                            flexShrink: 0,
                          }}
                          aria-hidden="true"
                        />
                        <input
                          id="txn-list-search"
                          type="search"
                          value={txnListSearch}
                          onChange={(e) => setTxnListSearch(e.target.value)}
                          placeholder="Search list…"
                          autoComplete="off"
                          aria-label="Search transactions in list"
                          style={{
                            flex: 1,
                            minWidth: 0,
                            width: "100%",
                            padding: "7px 10px",
                            fontSize: "13px",
                            borderRadius: "8px",
                            border: "1px solid rgba(255, 255, 255, 0.45)",
                            background: "rgba(255, 255, 255, 0.96)",
                            color: "#0f172a",
                            outline: "none",
                            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.08)",
                          }}
                          onFocus={(e) => {
                            e.target.style.background = "#ffffff";
                            e.target.style.borderColor = "rgba(255, 255, 255, 0.85)";
                          }}
                          onBlur={(e) => {
                            e.target.style.background = "rgba(255, 255, 255, 0.96)";
                            e.target.style.borderColor = "rgba(255, 255, 255, 0.45)";
                          }}
                        />
                        {txnListSearch.trim() ? (
                          <button
                            type="button"
                            onClick={() => setTxnListSearch("")}
                            style={{
                              padding: "5px 10px",
                              fontSize: "11px",
                              fontWeight: "700",
                              borderRadius: "8px",
                              border: "1px solid rgba(255, 255, 255, 0.55)",
                              background: "rgba(255, 255, 255, 0.22)",
                              color: "#ffffff",
                              cursor: "pointer",
                              flexShrink: 0,
                              whiteSpace: "nowrap",
                            }}
                          >
                            Clear
                          </button>
                        ) : null}
                      </div>
                      <div
                        style={{
                          flex: "0 1 280px",
                          minWidth: 0,
                          maxWidth: "100%",
                        }}
                      >
                        {renderTxnBatchToolbarBody(false)}
                      </div>
                    </div>
                  ) : null}
                </div>

                <div
                  className="txn-table-scroll"
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                    padding: "6px 10px 10px",
                    background: "linear-gradient(180deg, #fafbfc 0%, #ffffff 40%)",
                  }}
                >
                  <table
                    className="txn-table"
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                      borderCollapse: "separate",
                      borderSpacing: 0,
                      background: "#ffffff",
                      border: "1px solid rgba(226, 232, 240, 0.85)",
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.8)",
                    }}
                  >
                    <thead>
                      <tr>
                        {[
                          "__chk__",
                          "SN.",
                          "Receipt No",
                          "Student / Father",
                          "ClassName",
                          "Session",
                          "Txn Date",
                          "Month",
                          "Type",
                          "Mode",
                          "Amount",
                          "Actions",
                        ].map((h, hi) => (
                          <th
                            key={`txn-col-${hi}`}
                            style={{
                              textAlign:
                                hi === 10 ? "right" : hi === 0 || hi === 11 ? "center" : "left",
                              padding: "13px 14px",
                              fontSize: "11px",
                              color: "#64748b",
                              fontWeight: "800",
                              letterSpacing: "0.06em",
                              textTransform: hi === 11 ? "none" : "uppercase",
                              borderBottom: `2px solid ${COLORS.primary_color_shade5 || "#3b82f6"}33`,
                              whiteSpace: "nowrap",
                              position: "sticky",
                              top: 0,
                              zIndex: 2,
                              background: `linear-gradient(135deg, #eff6ff 0%, #dbeafe 55%, #e0f2fe 100%)`,
                              boxShadow: "inset 0 1px 0 rgba(255,255,255,0.65)",
                              ...(hi === 0
                                ? { width: "36px", maxWidth: "40px", padding: "11px 4px", boxSizing: "border-box" }
                                : {}),
                              ...(hi === 1
                                ? { width: "44px", maxWidth: "48px", padding: "11px 4px", boxSizing: "border-box" }
                                : {}),
                              ...(hi === 2
                                ? { width: "96px", maxWidth: "108px", padding: "11px 6px", boxSizing: "border-box" }
                                : {}),
                              ...(hi === 3
                                ? {
                                    minWidth: "180px",
                                    width: "22%",
                                    padding: "11px 12px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 4
                                ? {
                                    minWidth: "76px",
                                    width: "9%",
                                    maxWidth: "150px",
                                    padding: "11px 8px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 5
                                ? {
                                    minWidth: "115px",
                                    width: "11%",
                                    maxWidth: "200px",
                                    padding: "11px 10px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 6
                                ? {
                                    minWidth: "118px",
                                    width: "11%",
                                    padding: "11px 10px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 7
                                ? {
                                    minWidth: "105px",
                                    width: "10%",
                                    maxWidth: "180px",
                                    padding: "11px 10px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 8
                                ? {
                                    minWidth: "108px",
                                    width: "8%",
                                    maxWidth: "132px",
                                    padding: "11px 6px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 9
                                ? {
                                    minWidth: "96px",
                                    width: "7%",
                                    maxWidth: "118px",
                                    padding: "11px 6px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 10
                                ? {
                                    minWidth: "100px",
                                    width: "9%",
                                    maxWidth: "124px",
                                    padding: "11px 8px",
                                    boxSizing: "border-box",
                                  }
                                : {}),
                              ...(hi === 11
                                ? { width: "108px", maxWidth: "120px", padding: "11px 8px", boxSizing: "border-box" }
                                : {}),
                            }}
                          >
                            {hi === 0 ? (
                              <input
                                type="checkbox"
                                checked={allSelectableSelected}
                                onChange={toggleSelectAllTxns}
                                disabled={
                                  feeBatchLoading || selectableTxnRows.length === 0
                                }
                                aria-label="Select all transactions"
                                style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: COLORS.primary_color_shade5 || "#3b82f6" }}
                              />
                            ) : (
                              h
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {!feeBatchLoading &&
                        (!mFeeCollectionBatch || mFeeCollectionBatch.length === 0) && (
                        <tr>
                          <td colSpan={12} style={{ padding: 0, border: "none" }}>
                            <div
                              style={{
                                padding: "36px 20px",
                                textAlign: "center",
                                color: "#64748b",
                                fontWeight: "600",
                                fontSize: "14px",
                                background: "#fafbfc",
                              }}
                            >
                              <i
                                className="fa fa-inbox"
                                style={{
                                  fontSize: "36px",
                                  color: "#cbd5e1",
                                  marginBottom: "12px",
                                  display: "block",
                                }}
                              />
                              No transactions for this report.
                            </div>
                          </td>
                        </tr>
                      )}
                      {!feeBatchLoading &&
                        (mFeeCollectionBatch || []).length > 0 &&
                        (mFeeCollectionBatchFilteredSorted || []).length === 0 && (
                          <tr>
                            <td colSpan={12} style={{ padding: 0, border: "none" }}>
                              <div
                                style={{
                                  padding: "36px 20px",
                                  textAlign: "center",
                                  color: "#64748b",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  background: "#fafbfc",
                                }}
                              >
                                <i
                                  className="fa fa-filter"
                                  style={{
                                    fontSize: "36px",
                                    color: "#cbd5e1",
                                    marginBottom: "12px",
                                    display: "block",
                                  }}
                                />
                                No transactions match your filters or search.
                              </div>
                            </td>
                          </tr>
                        )}
                      {(mFeeCollectionBatchFilteredSorted || []).map((row, idx) => {
                        const txDate = row.transaction_date ? new Date(row.transaction_date) : null;
                        const monthLabel =
                          txDate && !Number.isNaN(txDate.getTime())
                            ? `${txDate.toLocaleString("en-US", { month: "long" })}-${txDate.getFullYear()}`
                            : "-";
                        const tid = String(row.transaction_id ?? "").trim();
                        const rowTxnSelected = tid ? selectedTxnIdSet.has(tid) : false;
                        const typeValue = row.transaction_for || "-";
                        const modeValue = row.payment_mode || "-";
                        const badge = (bg, fg) => ({
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "5px 11px",
                          borderRadius: "999px",
                          fontSize: "11px",
                          fontWeight: "800",
                          letterSpacing: "0.03em",
                          background: bg,
                          color: fg,
                          border: `1px solid ${fg}22`,
                          whiteSpace: "nowrap",
                          textTransform: "uppercase",
                          maxWidth: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          boxSizing: "border-box",
                        });

                        const zebraf = idx % 2 === 0 ? "#ffffff" : "#fafbfd";

                        return (
                          <tr
                            key={`${row.transaction_id || "txn"}_${idx}`}
                            className="txn-table-row"
                            style={{
                              borderBottom: "1px solid #f1f5f9",
                              background: zebraf,
                              transition: "background 0.15s ease, box-shadow 0.15s ease",
                            }}
                          >
                            <td
                              style={{
                                width: "36px",
                                maxWidth: "40px",
                                padding: "10px 4px",
                                verticalAlign: "middle",
                                textAlign: "center",
                                boxSizing: "border-box",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={rowTxnSelected}
                                onChange={() => toggleTxnRowSelected(row)}
                                disabled={!tid}
                                aria-label="Select transaction"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  cursor: tid ? "pointer" : "not-allowed",
                                  accentColor: COLORS.primary_color_shade5 || "#3b82f6",
                                }}
                              />
                            </td>
                            <td
                              style={{
                                width: "44px",
                                maxWidth: "48px",
                                padding: "10px 4px",
                                verticalAlign: "middle",
                                textAlign: "center",
                                boxSizing: "border-box",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  minWidth: "24px",
                                  height: "26px",
                                  padding: "0 6px",
                                  borderRadius: "8px",
                                  fontSize: "11px",
                                  fontWeight: "800",
                                  color: "#475569",
                                  background: "linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%)",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                {idx + 1}
                              </span>
                            </td>
                            <td
                              style={{
                                width: "96px",
                                maxWidth: "108px",
                                padding: "10px 6px",
                                fontSize: "11px",
                                color: "#334155",
                                fontWeight: "700",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontVariantNumeric: "tabular-nums",
                                boxSizing: "border-box",
                              }}
                              title={String(row.reciept_no ?? "").trim() || undefined}
                            >
                              {String(row.reciept_no ?? "").trim() || "-"}
                            </td>
                            <td
                              style={{
                                padding: "12px 14px",
                                verticalAlign: "middle",
                                minWidth: "180px",
                                width: "22%",
                                maxWidth: "380px",
                                boxSizing: "border-box",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "15px",
                                  color: "#0f172a",
                                  fontWeight: "800",
                                  lineHeight: 1.35,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                                title={row.stu_name || ""}
                              >
                                {row.stu_name || "-"}
                              </div>
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#64748b",
                                  fontWeight: "600",
                                  marginTop: "4px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                                title={row.father_name ? `Father: ${row.father_name}` : ""}
                              >
                                {row.father_name ? `F: ${row.father_name}` : "F: —"}
                              </div>
                            </td>
                            <td
                              style={{
                                padding: "12px 8px",
                                minWidth: "76px",
                                width: "9%",
                                maxWidth: "150px",
                                boxSizing: "border-box",
                                fontSize: "13px",
                                color: "#334155",
                                whiteSpace: "nowrap",
                                fontWeight: "700",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={row.class_name || undefined}
                            >
                              {row.class_name || "-"}
                            </td>
                            <td
                              style={{
                                minWidth: "115px",
                                width: "11%",
                                maxWidth: "220px",
                                padding: "12px 10px",
                                boxSizing: "border-box",
                                fontSize: "12px",
                                color: "#334155",
                                whiteSpace: "nowrap",
                                fontWeight: "700",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={row.session_name || undefined}
                            >
                              {row.session_name || "-"}
                            </td>
                            <td
                              style={{
                                minWidth: "118px",
                                width: "11%",
                                padding: "12px 10px",
                                boxSizing: "border-box",
                                fontSize: "12px",
                                color: "#475569",
                                whiteSpace: "nowrap",
                                fontVariantNumeric: "tabular-nums",
                              }}
                            >
                              {row.transaction_date || "-"}
                            </td>
                            <td
                              style={{
                                minWidth: "105px",
                                width: "10%",
                                maxWidth: "180px",
                                padding: "12px 10px",
                                boxSizing: "border-box",
                                fontSize: "12px",
                                color: "#64748b",
                                whiteSpace: "nowrap",
                                fontWeight: "700",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={monthLabel !== "-" ? monthLabel : undefined}
                            >
                              {monthLabel}
                            </td>
                            <td
                              style={{
                                minWidth: "108px",
                                width: "8%",
                                maxWidth: "132px",
                                padding: "10px 6px",
                                boxSizing: "border-box",
                                verticalAlign: "middle",
                                overflow: "hidden",
                              }}
                            >
                              <span style={badge("#eff6ff", "#2563eb")} title={typeValue}>
                                {typeValue}
                              </span>
                            </td>
                            <td
                              style={{
                                minWidth: "96px",
                                width: "7%",
                                maxWidth: "118px",
                                padding: "10px 6px",
                                boxSizing: "border-box",
                                verticalAlign: "middle",
                                overflow: "hidden",
                              }}
                            >
                              <span style={badge("#ecfdf5", "#059669")} title={modeValue}>
                                {modeValue}
                              </span>
                            </td>
                            <td
                              style={{
                                minWidth: "100px",
                                width: "9%",
                                maxWidth: "124px",
                                padding: "10px 8px",
                                boxSizing: "border-box",
                                fontSize: "13px",
                                color: COLORS.primary_color_shade5 || "#0f172a",
                                fontWeight: "900",
                                whiteSpace: "nowrap",
                                textAlign: "right",
                                fontVariantNumeric: "tabular-nums",
                                background: "linear-gradient(90deg, transparent 0%, rgba(241,245,249,0.5) 100%)",
                                borderLeft: "1px solid #f1f5f9",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={String(row.paid_amount ?? "")}
                            >
                              ₹ {row.paid_amount ?? "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 8px",
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => handleOpenTxnReceipt(row)}
                                disabled={!tid}
                                style={{
                                  padding: "6px 10px",
                                  fontSize: "11px",
                                  fontWeight: "700",
                                  borderRadius: "8px",
                                  border: `1px solid ${COLORS.primary_color_shade5 || "#3b82f6"}44`,
                                  background: "#eff6ff",
                                  color: COLORS.primary_color_shade5 || "#2563eb",
                                  cursor: tid ? "pointer" : "not-allowed",
                                  opacity: tid ? 1 : 0.45,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <i className="fa fa-receipt" style={{ marginRight: "6px" }} aria-hidden="true" />
                                Receipt
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    {!feeBatchLoading && (mFeeCollectionBatch || []).length > 0 && (
                      <tfoot>
                        <tr>
                          <td
                            colSpan={12}
                            style={{
                              padding: "12px 14px",
                              borderTop: "1px solid rgba(255, 255, 255, 0.12)",
                              background: `linear-gradient(135deg, #60a5fa 0%, ${COLORS.primary_color_shade5 || "#3b82f6"} 48%, #2563eb 100%)`,
                              textShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
                            }}
                          >
                            {renderTxnBatchToolbarBody()}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                  <style>{`
                    @keyframes txn-spin {
                      to { transform: rotate(360deg); }
                    }
                    .txn-table-scroll .txn-table tbody tr.txn-table-row:hover {
                      background: #f1f5f9 !important;
                      box-shadow: inset 3px 0 0 ${COLORS.primary_color_shade5 || "#3b82f6"};
                    }
                  `}</style>
                </div>
              </div>
            )}
          </>
        </div>
      </div>
    );
};

export default TransactionPanel;

